(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7363],{

/***/ 3910:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel-room-in-shimla",
      function () {
        return __webpack_require__(4526);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const AccomodationSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Apartment",
                    "name": "The Twin Towers Hotel",
                    "description": "One of the best hotel in Kufri, it is located in the heart of town, amid the Himalayan foothills. The location is a beautiful retreat in a mountainous neighborhood, offering visitors a tranquil, calm, and pleasant atmosphere for a soul-filling holiday, and being so near to nature offers a choice of activities that will nourish your spirit. It will undoubtedly assist you in unwinding while you participate in the most exciting activities with your loved ones at and around the resort, since it is a great site for fun activities such as adventure sports, walks and trails, and so on.",
                    "numberOfRooms": 3,
                    "occupancy": {
                        "@type": "QuantitativeValue",
                        "minValue": 1,
                        "maxValue": 4
                    },
                    "floorLevel": 5,
                    "floorSize": {
                        "@type": "QuantitativeValue",
                        "value": 81,
                        "unitCode": "MTK"
                    },
                    "numberOfBathroomsTotal": 2,
                    "numberOfBedrooms": 2,
                    "petsAllowed": true,
                    "tourBookingPage": "",
                    "yearBuilt": 2014,
                    "telephone": "+91 07807885113",
                    "address": {
                        "@type": "PostalAddress",
                        "addressCountry": "IN",
                        "addressLocality": "NH 05, New kufri, Galu, Hills",
                        "addressRegion": "Indian Himalayan Region",
                        "postalCode": "171209",
                        "streetAddress": "NH 05, New kufri, Galu, Hills"
                    },
                    "latitude": 31.100830,
                    "longitude": 77.264710
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (AccomodationSchema);


/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BreadCrumbSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "About Us",
                            "item": "https://www.hoteltwintowers.com/about-us"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Room and Suits",
                            "item": "https://www.hoteltwintowers.com/hotel-room-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Bar and Restaurant",
                            "item": "https://www.hoteltwintowers.com/bar-and-restaurant"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": "Events",
                            "item": "https://www.hoteltwintowers.com/#events"
                        },
                        {
                            "@type": "ListItem",
                            "position": 5,
                            "name": "Banquet Halls in Shimla",
                            "item": "https://www.hoteltwintowers.com/banquet-halls-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 6,
                            "name": "Conference Halls",
                            "item": "https://www.hoteltwintowers.com/conference-hall"
                        }
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbSchema);


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 4526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ RoomsandSuites; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(731);
/* harmony import */ var _styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6240);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var _components_Loader_NewLoader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4538);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7803);
/* harmony import */ var _components_Schema_HotelSchema_breadcrumb__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9881);
/* harmony import */ var _components_Schema_HotelSchema_accomodation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7782);













var __N_SSG = true;
function RoomsandSuites(param) {
    let { Allrooms  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [noOfNights, setNoOfNights] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(router.query.npOfNights || 1);
    const [startDate, setStartDate] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(new Date());
    const [endDate, setEndDate] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(()=>{
        const tomorrow = (0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(new Date(), 1);
        return tomorrow;
    });
    const [checkin, setCheckin] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        day: router.query.checkinDay || "",
        month: router.query.checkinMonth || "",
        year: router.query.checkinYear || ""
    });
    const [checkout, setCheckout] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        day: router.query.checkoutDay || "",
        month: router.query.checkoutMonth || "",
        year: router.query.checkoutYear || ""
    });
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const updateDateState = (date, setStateFunction)=>{
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({
                    day,
                    month,
                    year
                });
            }
        };
        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);
        const nights = moment__WEBPACK_IMPORTED_MODULE_8___default()(endDate).diff(moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate), "days");
        setNoOfNights(nights > 0 ? nights : 1);
    }, [
        startDate,
        endDate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const nights = (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(endDate, startDate);
        setNoOfNights(nights);
    }, [
        startDate,
        endDate
    ]);
    const formated_start_date = moment__WEBPACK_IMPORTED_MODULE_8___default()(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment__WEBPACK_IMPORTED_MODULE_8___default()(endDate).format("YYYY-MM-DD");
    const handleSubmit = async (event, hotelId)=>{
        event.preventDefault();
        setLoader(true);
        try {
            await router.push("/searchresults/?hotelID=".concat(hotelId, "&checkinDay=").concat(checkin.day, "&checkinMonth=").concat(checkin.month, "&checkinYear=").concat(checkin.year, "&checkoutDay=").concat(checkout.day, "&checkoutMonth=").concat(checkout.month, "&checkoutYear=").concat(checkout.year, "&room=1&adult=2&children=0&checkIn=").concat(formated_start_date, "&checkOut=").concat(formated_end_date, "&noOfNights=").concat(noOfNights), undefined, {
                shallow: false
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally{
            setLoader(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Book Best hotel Room in Shimla- The Twin Towers hotel in Shimla  | Luxury and Deluxe rooms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Book your stay at The Twin Towers Hotel in Shimla for Family, Couple luxurious, elegant rooms with stunning views. Reserve now for an unforgettable experience!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/hotel-room-in-shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Shimla Hotel Room Price, Shimla Hotel Booking, shimla hotel room booking, room suites, best tourist places to visit in shimla, hotel room images, room luxury, hotel room types, shimla room rent "
                    })
                ]
            }),
            loader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loader_NewLoader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                bgImage: "/images/our-rooms-banner.png",
                title: "Explore the best Room Suites"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: Allrooms.map((room, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms_main), " row align-items-center"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms_left), " col-md-4"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: room.roomsImage,
                                        alt: room.roomName
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms_center), " col-md-5 common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: room.roomName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms_center_desc),
                                            children: room.roomDesc
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms_center_amen),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: "/icons/bed.svg",
                                                        height: 20,
                                                        width: 23,
                                                        alt: "bed-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().right_amen),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: "/icons/guests.svg",
                                                        height: 20,
                                                        width: 23,
                                                        alt: "guests-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().right_amen),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: "/icons/coffee.svg",
                                                        height: 20,
                                                        width: 23,
                                                        alt: "coffee-icon"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_pages_Rooms_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rooms_right), " col-md-3 common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "common_btn",
                                            onClick: (event)=>handleSubmit(event, 17),
                                            children: "Book Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            className: "secound_common_btn",
                                            href: "/hotel-room-in-shimla/".concat(room.slug),
                                            children: "More Details"
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Schema_HotelSchema_breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Schema_HotelSchema_accomodation__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rooms":"Rooms_rooms__NlERG","rooms_main":"Rooms_rooms_main__HdrVW","rooms_left":"Rooms_rooms_left__jIfOA","rooms_right":"Rooms_rooms_right__ZwXWC","rooms_center":"Rooms_rooms_center__N80h9","rooms_center_amen":"Rooms_rooms_center_amen__qKl6E","right_amen":"Rooms_right_amen__LGwZN","rooms_center_desc":"Rooms_rooms_center_desc__fU4ll","single_blog":"Rooms_single_blog__xXf7q","gallery_main":"Rooms_gallery_main__ov7_C","gallery_child":"Rooms_gallery_child__IAOAc","booking_cont":"Rooms_booking_cont__d7mEW","booking_col":"Rooms_booking_col__SSMlh","button_col":"Rooms_button_col__P3pMY","check_now_btn":"Rooms_check_now_btn__Exk75","amenities_main":"Rooms_amenities_main__qdnqd","amenities_child":"Rooms_amenities_child__BWEL5","similar_rooms":"Rooms_similar_rooms__WyJ6m","similar_room_child":"Rooms_similar_room_child__XdoqR","bg_image":"Rooms_bg_image__59AXv","similer_inner_text":"Rooms_similer_inner_text__3NYBn","delux_icone":"Rooms_delux_icone__pq_fe"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3910); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);